var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.544 3.469a.7.7 0 0 1 .911 0l8.245 7.066v8.322a1.843 1.843 0 0 1-1.843 1.843h-4.571a.7.7 0 0 1-.7-.7v-3.428a1.586 1.586 0 1 0-3.172 0V20a.7.7 0 0 1-.7.7H5.143A1.843 1.843 0 0 1 3.3 18.857v-8.322l8.244-7.066ZM4.7 11.179v7.678c0 .245.198.443.443.443h3.871v-2.729a2.986 2.986 0 1 1 5.972 0V19.3h3.87a.443.443 0 0 0 .444-.443V11.18L12 4.922l-7.3 6.257Z"
})));
export { SvgHome as ReactComponent };
export default __webpack_public_path__ + "dec04982ed607f3e9b981ce67a7fc740.svg";